import { BaseButton, type BaseButtonProps } from './BaseButton';
import styles from './AccentButton.module.scss';

export function AccentButton(props: BaseButtonProps): React.ReactElement {
  const { children, ...restProps } = props;

  return (
    <BaseButton {...restProps} className={styles.accentButton}>
      {children}
    </BaseButton>
  );
}
